export default "__VITE_ASSET__C6x99s_o__"